import actionTypes from "actions/actionTypes";

const initialState = {
  url: null
};

const iframeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPEN_URL:
      return {
        ...state,
        url: action.url
      };
    case actionTypes.CLOSE_URL:
      return {
        ...state,
        url: null
      };
    default:
      return state;
  }
};

export default iframeReducer;
